import { useEffect } from 'react';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { BANNER_WIDGET_LAYOUT_TYPE_V2, BannerWidgetDetailV2 } from '../../../../../types/widget';

type UseBannerWidgetFormReturnType = {
  layoutType?: BannerWidgetDetailV2['layoutType'];
  widgetItemBanners?: BannerWidgetDetailV2['widgetItemBanners'];
  handleChangeLayoutType: (layoutType: BANNER_WIDGET_LAYOUT_TYPE_V2) => void;
};

interface UseBannerWidgetFormProps {
  form: WrappedFormUtils;
  initialValue: Partial<BannerWidgetDetailV2>;
}

const useBannerWidgetForm = (props: UseBannerWidgetFormProps): UseBannerWidgetFormReturnType => {
  const { form, initialValue } = props;

  const { layoutType, widgetItemBanners } = form.getFieldsValue(['layoutType', 'widgetItemBanners']) as Pick<
    Partial<BannerWidgetDetailV2>,
    'layoutType' | 'widgetItemBanners'
  >;

  useEffect(() => {
    form.setFieldsValue(initialValue);
  }, []);

  const handleChangeLayoutType = (): void => {
    if (widgetItemBanners && widgetItemBanners.length > 0) {
      form.setFieldsValue({
        widgetItemBanners: widgetItemBanners.map((item) => {
          const { isUseBannerTitle, title, contents, ...rest } = item;
          return rest;
        }),
      });
    }
  };

  return { layoutType, widgetItemBanners, handleChangeLayoutType };
};

export default useBannerWidgetForm;
